import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'


import { MainLayoutComponent } from './main.component'
import { SharedModule } from 'src/app/shared/shared.module'
import { MatToolbarModule } from '@angular/material/toolbar'

@NgModule({
    declarations: [MainLayoutComponent],
    imports: [
        RouterModule,
        CommonModule,
        SharedModule,
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
],
    exports: [MainLayoutComponent],
    providers: []
})
export class MainLayoutModule {}
